<template>
  <!-- External link -->
  <a
    :class="['button', variant ? `button--${variant}` : null]"
    :href="url"
    target="_blank"
    v-if="external"
  >
    {{ text }}
  </a>

  <!-- Internal link -->
  <router-link :class="['button', variant ? `button--${variant}` : null]" :to="url" v-else>{{
    text
  }}</router-link>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    external: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  cursor: pointer;
  display: block;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 15px;
  text-align: center;
  text-decoration: none;
  width: 100%;

  &--primary {
    background-color: $color-primary;
    color: $color-white;
    padding: 12px 5px;

    &:not(.button--outline) {
      @include button-gradient;
    }

    &:focus,
    &:hover {
      &:not(.button--outline) {
        @include button-gradient-hover;
      }
    }
  }

  &--outline {
    background-color: $color-white;
    border: 1px solid $color-primary;
    color: $color-primary;
    padding: 11px 5px;
  }
}
</style>
